
export enum DimensionType {

	// Draws the dimension lines inside the coordinates provided
	'Inside',

	// Draws the dimension lines outside the coordinates provided
	'Outside'
}
